export const calculateRadius = (map) => {
    const bounds = map.getBounds();
    if (!bounds) {
        return 0;
    }
    const northSouthRadius = google.maps.geometry.spherical.computeDistanceBetween(bounds.getCenter(), new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getCenter().lng()));
    const eastWestRadius = google.maps.geometry.spherical.computeDistanceBetween(bounds.getCenter(), new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getCenter().lng()));
    const radius = northSouthRadius <= eastWestRadius ? northSouthRadius : eastWestRadius;
    return Number(radius.toFixed(2));
};
//# sourceMappingURL=calculateRadius.js.map